var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "share-content"
  }, [_c("div", {
    staticStyle: {
      background: "linear-gradient(#f8efff, #e0f4ff)"
    }
  }, [_c("div", {
    staticClass: "share-header"
  }, [_c("van-image", {
    attrs: {
      src: _vm.logoUrl,
      height: "36px",
      width: "120px"
    }
  })], 1), _vm._l(_vm.alogList, function (log, index) {
    return _c("div", {
      key: index,
      staticClass: "share-body"
    }, [_c("div", {
      staticClass: "question-box-wrapper"
    }, [_c("div", {
      staticClass: "question-box",
      domProps: {
        innerHTML: _vm._s(_vm.renderMessage(log.question))
      }
    })]), _c("div", {
      staticClass: "answer-box m-t-32",
      domProps: {
        innerHTML: _vm._s(_vm.renderMarkDown(log.alogList))
      }
    })]);
  }), _c("div", {
    staticClass: "share-footer"
  }, [_c("van-image", {
    attrs: {
      src: _vm.footerUrl
    }
  }), _c("div", {
    staticClass: "share-qrcode"
  }, [_c("van-image", {
    attrs: {
      src: _vm.qrCodeBase64
    }
  })], 1)], 1)], 2), _c("div", {
    staticClass: "ty-btn",
    on: {
      click: _vm.tryItNow
    }
  }, [_vm._v("立即体验")])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };